import { t } from 'i18next';

import { ContextMenuItem } from '../../../../../../react/components/skyview/context-menu';
import { isDefined } from '../../../../../../utils/variables';
import { findPointIdFromIntersection } from '../../../../../elements/design/design-node/utils/point-node';
import { ActionName, DesignTool } from '../../../../design-tool';
import { selectLines } from '../utils/select';
import { selectPolylineUtils } from './features/select-polyline-utils';

export const startPolylineSelection = (tool: DesignTool): ContextMenuItem => {
  const intersectedPointId = findPointIdFromIntersection(tool.asset.designNode, tool.intersection);
  const intersectionPoint = tool.intersection?.point.clone();
  const disabled = !isDefined(intersectedPointId) || !isDefined(intersectionPoint);

  return {
    title: t('contextMenu.beginSelectPolylineAction', {
      ns: 'skyviewDesign',
    }),
    action: () => {
      if (disabled) {
        return;
      }
      initPolylineSelectionAction(tool);
      tool.contextMenuCallback?.();
    },
    disabled,
  };
};

const initPolylineSelectionAction = (tool: DesignTool): void => {
  return selectPolylineUtils.initAction(
    tool,
    ActionName.SelectPolyLine,
    (paths) => {
      const lines = paths.map((x) => x.nodes).flat();
      selectLines(tool, lines);
    },
    false,
  );
};
